// Putting right, from an analysis view, a node a finding rests on. Pure, so it can be tested without a page; the
// NodeCorrectionService sends what it builds
import { createLinqsetChanges, LinqsetChanges } from '../common/linqset-change-model';
import { CURRENT_STATE_PROJECT_KEY, NODE_TYPE, NodeProperties } from '../common/linqset-model';
import { Organisation } from '../common/organisation';
import { USER_ROLE } from '../common/user';

// a change to one node, made from an analysis view rather than in its model
export interface NodeCorrection {
    modelKey: string;
    key: string;
    properties?: Partial<NodeProperties>;
    type?: NODE_TYPE;
    informationAssetKey?: string | null;    // the information asset it is a state of; null unlinks it
}

// changes can be made from a view to current state only, by those who can change the organisation, as the insights
// they rescore are the organisation's
export const canCorrect = (organisation: Organisation | undefined, workspaceKey: string) =>
    workspaceKey === CURRENT_STATE_PROJECT_KEY && !!organisation && (organisation.role || USER_ROLE.READ) <= USER_ROLE.WRITE;

// the changes for each model, as its graph takes them: each node once, with what changed on it
export const correctionChanges = (corrections: NodeCorrection[]) => {
    const changes: { [modelKey: string]: LinqsetChanges } = {};
    corrections.forEach(({ modelKey, key, properties, type, informationAssetKey }) => {
        const forModel = changes[modelKey] ||= createLinqsetChanges();
        const existing = forModel.nodeChanges.find(c => c._key === key);
        const change = existing || { _key: key };
        if (properties) change.properties = { ...(change.properties || {}), ...properties };
        if (type) change.type = type;
        if (informationAssetKey !== undefined) change.informationAssetKey = informationAssetKey || null;
        if (!existing) forModel.nodeChanges.push(change);
    });
    return changes;
};
